export default __webpack_public_path__ + "static/media/Group 8.86c446e7.png";